import React, { useState } from 'react';
import {
    SandpackProvider,
    SandpackLayout,
    SandpackCodeEditor,
    SandpackPreview,
} from "@codesandbox/sandpack-react";
import { atomDark } from "@codesandbox/sandpack-themes";
import './CodeEditor.css';

const TEMPLATES = [
    {
        label: "React",
        template: "react",
        files: {
            "/App.js": `export default function App() {\n  const competences = [\n    "Curieux",\n    "Autonome",\n    "Passionné",\n    "Esprit d’équipe"\n  ];\n\n  return (\n    <>\n     <h1>Mes compétences:</h1>\n     <ul>\n       {competences.map((c, i) => (\n         <li key={i}>{c}</li>\n       ))}\n     </ul>\n    </>\n  );\n}`,
        },
    },
    {
        label: "HTML / CSS / JS",
        template: "static",
        files: {
            "/index.html": `<!DOCTYPE html>\n<html>\n  <head>\n    <link rel="stylesheet" href="styles.css" />\n  </head>\n  <body>\n    <h1>Centres d'intérêt :</h1>\n    <ul>\n      <li>Informatique</li>\n      <li>Aéronautique</li>\n      <li>Sports mécanique</li>\n      <li>Airsoft</li>\n    </ul>\n    <script src="index.js"></script>\n  </body>\n</html>`,
            "/styles.css": `body { \n  font-family: sans-serif; \n  background: #1a1a2e; \n  color: #fff; \n  display: flex; \n  justify-content: center; \n  align-items: center; \n  height: 100vh; margin: 0; \n  flex-direction:column; \n}\nli { \n  font-size:20px; \n}`,
            "/index.js": `console.log("Hello from JS!");`,
        },
    },
    {
        label: "Vanilla JS",
        template: "vanilla",
        files: {
            "/index.js": `let text = "Modifiez moi !";\n//Amusez vous a modifier le texte au dessus !\n//C'est bien a vous, visteur que je parle.\nlet app = document.getElementById("app");\napp.innerHTML = "<h1>"+text+"</h1>";`,
        },
    },
];

const CodeEditor = () => {
    const [selected, setSelected] = useState(0);
    const current = TEMPLATES[selected];
    const technologies =["React js","Symfony","BootStrap","HTML","CSS", "PHP","JavaScript","Mercure","Firebase","Flask","SQL/PLSQL", "TWIG","Python", "C","C++", "Java"]
    return (
        <div className="codeeditor-container">
            <div className="codeeditor-tabs">
                {TEMPLATES.map((t, i) => (
                    <button
                        key={t.label}
                        className={`codeeditor-tab ${i === selected ? "active" : ""}`}
                        onClick={() => setSelected(i)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
            <SandpackProvider
                key={current.label}
                template={current.template}
                files={current.files}
                theme={atomDark}
            >
                <SandpackLayout>
                    <SandpackCodeEditor showLineNumbers showTabs closableTabs />
                    <SandpackPreview showNavigator />
                </SandpackLayout>
            </SandpackProvider>
        </div>
    );
};

export default CodeEditor;
